import getWXSign from './wxSign'
import axios, { post } from 'axios'
import apiServe from './apiServe';
import trackFn from "../../public/js/trackFn"

export default function wxShare() {
    return new Promise((resolve, reject) => {
        getWXSign()
            .then(jssdk => {
                apiServe.invitation({}).then(res => {
                    const configData = res.data;
                    console.log('globalres',res)
                    jssdk.onMenuShareTimeline({
                        title: configData.title, // 分享标题
                        desc: configData.subtitle, // 分享描述
                        link: configData.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: configData.picUrl, // 分享图标
                        success: function () {
                            trackFn.send("click_share_to", {
                                // 分享 - 埋点
                                item_id: configData.shareUrl,
                                item_type: "url",
                                current_page_url: "recruit",
                                params: "wxCircle",
                            });
                        }
                    });
                    jssdk.onMenuShareAppMessage({
                        title: configData.title, // 分享标题
                        desc: configData.subtitle, // 分享描述
                        link: configData.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: configData.picUrl, // 分享图标
                        success: function () {
                            trackFn.send("click_share_to", {
                                // 分享 - 埋点
                                item_id: configData.shareUrl,
                                item_type: "url",
                                current_page_url: "recruit",
                                params: "wx",
                            });
                        }
                    })
                })
            })
    })
}
